import { render, staticRenderFns } from "./HDXTratamientos.vue?vue&type=template&id=4193806c&scoped=true"
import script from "./HDXTratamientos.vue?vue&type=script&lang=js"
export * from "./HDXTratamientos.vue?vue&type=script&lang=js"
import style0 from "./HDXTratamientos.vue?vue&type=style&index=0&id=4193806c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4193806c",
  null
  
)

export default component.exports